
import FormControl from "../../MUI_components/FormControl/fomikFormControl";
import { Form, Formik, FieldArray, Field } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openSnackbar } from "../../../Redux/Actions/snackbarActions";
import Loading from "Components/MUI_components/loading";
import { Button, Paper } from "@mui/material";
import Title from "../../Card/title";

import ClosingBalanceService from "Service/Accounts/ClosingBalance.service";
import { COLUMNS_NAME } from "Components/Constants/ColumnsNames";
import { currency } from "Components/MUI_components/currencyFormatterTag";
import Reports from "Components/Print/a4-report-print";
import ReactToPrint from "react-to-print";
import { DownloadTableExcel } from "react-export-table-to-excel";
import { pageStyle } from "Components/Print/printPagesStyles";

export default function GeneralLedger() {


    const today = new Date().toISOString().split("T")[0];
    const [task, setTask] = useState("generate");
    const [status, setStatus] = useState({
        closingBalanceAvailable: false
    });
    const componentRef = React.useRef();
    const tableRef = useRef(null);
 
    const dispatch = useDispatch();
    // const [isLoaded, setIsLoaded] = useState(false);
    const [loading, setLoading] = React.useState(false);
    const [initLoad, setInitLoad] = React.useState(true);

    const [value, setvalue] = useState([]);


    const handleSubmit = async (values, onSubmitProps) => {
        try {
            if (task === "checkStatus") {
                checkLedgerStatus(values);
            }
            else if (task === "preview") {
                let val = {
                    ...values,
                    task: task
                }
                previewClosingBalance(val);
            }
            else {
                let val = {
                    ...values,
                    task: task
                }
                previewClosingBalance(val);
            }

            // dispatch(
            //     openSnackbar(
            //         true,
            //         "success",
            //         `Generated Successfully`
            //     )
            // );
            // // dispatch(getLastInsertInvoice(res));

            // onSubmitProps.resetForm();
        } catch (e) {
            dispatch(openSnackbar(true, "error", e));
        }
    };


    const checkLedgerStatus = async (values) => {
        setLoading(true);
        setInitLoad(true);
        try {
            const res = await ClosingBalanceService.getClosingBalanceByDate(values);

            //console.log(res);
            if (res.length === 0) {
                setStatus({
                    ...status,
                    closingBalanceAvailable: false
                });
                setInitLoad(false);
            }
            else {
                setStatus({
                    ...status,
                    closingBalanceAvailable: true
                });
                setInitLoad(false)
            }
        } catch (e) {
            setInitLoad(true);
            dispatch(openSnackbar(true, "error", e));
        }
        setLoading(false);
    };




    const previewClosingBalance = async (values) => {
        try {
            const res = await ClosingBalanceService.previewClosingBalance(values);
            setInitLoad(true);
            setvalue(res)
        } catch (e) {
            dispatch(openSnackbar(true, "error", e));
        }
    };

    const DebitTotal = value.map((row) => row.entryType == 0 ? parseFloat(row.amount) : 0)
        .reduce((sum, i) => sum + i, 0);

    const creditTotal = value.map((row) => row.entryType == 1 ? parseFloat(row.amount) : 0)
        .reduce((sum, i) => sum + i, 0);

    return (
        <>
            <Title>Generate General Ledger</Title>
            <Paper style={{ paddingBottom: 10 }}>
                <Formik initialValues={{
                    date: today,
                    ledgerType: null
                }}

                    onSubmit={handleSubmit}

                >
                    {(props) => {
                        return (
                            <Form>
                                <div className="row" style={{ padding: "10px 0" }}>

                                    <div className=" col-4" style={{ margin: "0rem 4.5rem" }}>
                                        <FormControl
                                            control="input"
                                            type="date"
                                            name="date"
                                            size="small"
                                            label="Date"
                                            inputProps={{
                                                max: today,
                                            }}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="col-2">
                                        <Button
                                            variant="contained"
                                            color="secondary"
                                            type="submit"
                                            onClick={() => { setTask("checkStatus") }}
                                        >
                                            Check Status
                                        </Button>
                                    </div>
                                    <div className="col-3">
                                        <Button
                                            variant="contained"
                                            color="error"
                                            type="submit"
                                            onClick={() => { setTask("generate") }}
                                        >
                                            Generate and Day Close
                                        </Button>
                                    </div>



                                </div>

                                <div className="mt mb">
                                    {loading ? (
                                        <Loading height={100} text="Loading.." />
                                    ) : !initLoad && (
                                        <div>
                                            {!status.closingBalanceAvailable && (
                                                <><div style={{ textAlign: 'center' }}>Closing Balance Not Available</div>

                                                </>
                                            )}
                                            <div className="mb-3 row flex-end" style={{ marginBottom: 10 }}>
                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    type="submit"
                                                    onClick={() => { setTask("preview"); }}
                                                >
                                                    Preview
                                                </Button>
                                            </div>

                                        </div>
                                    )}
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </Paper>
            <div >
                {value.length > 0 && (
                    <Paper style={{ padding: "10px" }}>
                        <div className="flex-end">
                            <ReactToPrint
                                trigger={() => (
                                    <Button
                                        style={{ margin: 5 }}

                                        variant="contained"
                                    >
                                        Print
                                    </Button>
                                )}
                                content={() => componentRef.current}
                                pageStyle={pageStyle.a4}
                            />
                            <DownloadTableExcel
                                filename="Day End"
                                currentTableRef={tableRef.current}
                            >
                                <Button
                                    style={{ margin: 5 }}

                                    variant="contained"
                                >
                                    Export to Excel </Button>
                            </DownloadTableExcel>

                        </div>
                        <div className="justify-content-center"
                            ref={componentRef}>
                            <Reports
                            // title={
                            //     dayEnd.rows.status
                            //         ? `Day End : ${dayEnd.date}`
                            //         : ""
                            // }

                            >
                                <table
                                    className="print-table mt "
                                    aria-label="customized table"
                                    ref={tableRef}>
                                    <thead className="thead" style={{ borderBottom: "1px solid #24242450" }}>
                                        <tr style={{ backgroundColor: "#cacaca" }}>
                                            <th width="10">#</th>
                                            <th align="left">{COLUMNS_NAME.TRANSACTION_TYPE}</th>
                                            <th align="left">{COLUMNS_NAME.LEDGER_TYPE}</th>
                                            {/* <th align="left" >{COLUMNS_NAME.ENTRY_TYPE}</th> */}
                                            <th align="left">{COLUMNS_NAME.TRANSACTION_MODE}</th>
                                            <th align="right">{COLUMNS_NAME.DEBIT}</th>
                                            <th align="right">{COLUMNS_NAME.CREDIT}</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <>
                                            {value.map((row, index) => (
                                                <>
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td align="left">
                                                            {row.sourceCode == 1 ? "Payment Receipt Total" : "" ||
                                                                row.sourceCode == 2 ? "Cash Payment" : "" ||
                                                                    row.sourceCode == 3 ? "Cheque Payment" : "" ||
                                                                        row.sourceCode == 4 ? "Card Payment  " : "" ||
                                                                            row.sourceCode == 5 ? "Bank Payment" : "" ||
                                                                                row.sourceCode == 6 ? "Return Amount" : "" ||
                                                                                    row.sourceCode == 7 ? "Over Payment" : "" ||
                                                                                        row.sourceCode == 8 ? "Expenses" : "" ||
                                                                                            row.sourceCode == 9 ? "Payment Voucher Total" : "" ||
                                                                                                row.sourceCode == 10 ? "Supplier Cash Payment" : "" ||
                                                                                                    row.sourceCode == 11 ? "Supplier Cheque Payment" : "" ||
                                                                                                        row.sourceCode == 12 ? "Supplier Card Payment" : "" ||
                                                                                                            row.sourceCode == 13 ? "Supplier BankPayment" : "" ||
                                                                                                                row.sourceCode == 14 ? "Purchase Return" : "" ||
                                                                                                                    row.sourceCode == 15 ? "Sales Return" : "" ||
                                                                                                                        row.transactionTypeName ? row.transactionTypeName : ""
                                                            }
                                                        </td>
                                                        <td align="left">
                                                            {row.ledgerType == 4601000001 ? "CASH BOOK" : "" ||
                                                                row.ledgerType == 4601000002 ? "BANK " : "" ||
                                                                    row.ledgerType == 4601000003 ? "CREDIT CARD" : ""}
                                                        </td>
                                                        <td align="left">{row.transactionType == 0 ? " CASH" : "CHEQUE"}</td>
                                                        <td align="right">{row.entryType == 0 ? row.amount : "-"}</td>
                                                        <td align="right">{row.entryType == 0 ? "-" : row.amount}</td>
                                                    </tr>
                                                </>
                                            ))}
                                            <tr>
                                                <td colSpan={4}></td>
                                                <td align="right">{currency(DebitTotal)}</td>
                                                <td align="right">{currency(creditTotal)}</td>
                                            </tr>

                                        </>
                                    </tbody>
                                </table>

                            </Reports>

                        </div>
                        <div className="mb-3 row flex-end" >

                        </div>


                    </Paper>
                )}

            </div>

        </>
    );

}

